function initScrollImage() {
  const elements = Array.from(document.querySelectorAll('.scroll-image'));
  if (!elements.length) return;

  // Cache natural elTop without transform (measured once after full layout)
  const targets = elements.map((el) => ({
    el,
    parent: el.parentElement,
    elTop: null,
  }));

  function measure() {
    const scrollY0 = window.scrollY;
    targets.forEach((t) => {
      // Temporarily remove transform to get natural position
      const prev = t.el.style.transform;
      t.el.style.transform = 'none';
      t.elTop = t.el.getBoundingClientRect().top + scrollY0;
      t.el.style.transform = prev;
    });
  }

  function update() {
    const scrollY = window.scrollY;
    const vh = window.innerHeight;

    targets.forEach(({ el, parent, elTop }) => {
      // parentBottom live (parent has no transform, safe to read)
      const parentBottom = parent.getBoundingClientRect().bottom + scrollY;

      const animStart = Math.max(elTop - vh, 0);
      const animEnd   = Math.max(parentBottom - vh, animStart + 1);

      const progress = Math.min(Math.max((scrollY - animStart) / (animEnd - animStart), 0), 1);
      el.style.transform = `translateY(${-100 * (1 - progress)}px)`;
    });
  }

  window.addEventListener('scroll', update, { passive: true });

  // Measure after full layout (images loaded)
  window.addEventListener('load', () => {
    measure();
    update();
  });

  // Fallback if load already fired
  if (document.readyState === 'complete') {
    measure();
    update();
  }
}

document.addEventListener('DOMContentLoaded', initScrollImage);
